<script >       
    import { createEventDispatcher ,onMount} from 'svelte';
    let canvas;
    let context;
    let result = -1;
    const dispatch = createEventDispatcher()
    function drawT(ctx){
        ctx.font = '48px serif';
        let  x = Math.ceil(Math.random() * 10)
        let y = Math.ceil(Math.random() * 10)
        ctx.rotate(10 * Math.PI / 180);
        result = x + y
        let t = x + '+' + y
        ctx.fillText(t , 100, 10);
    }
    onMount(()=>{
        context = canvas.getContext('2d')
        drawT(context)
        dispatch('change',{result})

    })
</script>
<div class="border-2 border-white bg-white w-full" >
    <canvas id="captcha"  height="50" class="bg-blue-100 w-full" style="direction:ltr" 
    	bind:this={canvas}/>
</div>

